<template>
	<div>
		<div id="fund-stat-body">
			<h3 class="module-title">Fund Statistics</h3>
			<div class="statistics-container">
				<div v-for="(item, index) in FundStatisticsData.data" :key="index" class="inline-item">
					<div class="value">{{ item.data }}</div>
					<div class="value-label">
						<sticky-text-wrap :text-content="formatLabelText(item.label)">
							<template #superscript1>
								<disclosure-superscript v-if="item.label === 'Average Life'" class="detail-page" anchor="fundstatistics" :statistics="['avgLife']" />
							</template>
							<template #Iball_avgLife>
								<i-ball-modal v-if="item.label === 'Average Life'" tag="BS_AL" />
							</template>
							<template #Iball_effectiveDur>
								<i-ball-modal v-if="item.label === 'Effective Duration'" tag="BS_ED" />
							</template>
							<template #Iball_yieldMat>
								<i-ball-modal v-if="item.label === 'Average Yield To Maturity'" tag="BS_YLDMAT" />
							</template>
							<template #Iball_yieldWor>
								<i-ball-modal v-if="item.label === 'Average Yield To Worst'" tag="BS_YTW" />
							</template>
							<template #Iball_avgCoup>
								<i-ball-modal v-if="item.label === 'Average Coupon'" tag="AVGCOUP" />
							</template>
						</sticky-text-wrap>
					</div>
				</div>
			</div>
			<div class="sub-info">{{ FundStatisticsData.asOfDate }}</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
	name: 'FundStatisticsWrapper',
	computed: {
		...mapGetters(['getFundStatistics']),
		FundStatisticsData() {
			const val = {
				data: [],
				asOfDate: ''
			};
			if (this.getFundStatistics) {
				val.data = [
					//CG-17294 hot fix 1/23 to remove averagelife datapoint accross all sites
					// this.getFundStatistics.AverageLife,
					this.getFundStatistics.EffectiveDuration,
					this.getFundStatistics.BSYieldFlag === 1
						? this.getFundStatistics.BSYieldToWorst
						: this.getFundStatistics.AverageYieldMaturity,
					this.getFundStatistics.AverageCoupon
				];
				val.asOfDate = `% of net assets as of ${this.getFundStatistics.FundStatAsOfDate} (updated quarterly)`;
			}
			this.$EventBus.$emit('ExcelData', 'FundStatisticsModule', val);
			return val;
		}
	},
	methods: {
		nullCheckYear(val) {
			return val ? `${val} years` : '--';
		},
		formatLabelText(text) {
			const first = text.split(' ');
			const last = first.pop();
			const slots = {
				'Average Life': [
					{ slotName: 'superscript1' },
					{ slotName: 'Iball_avgLife' }
				],
				'Effective Duration': [{ slotName: 'Iball_effectiveDur' }],
				'Average Yield To Maturity': [{ slotName: 'Iball_yieldMat' }],
				'Average Yield To Worst': [{ slotName: 'Iball_yieldWor' }],
				'Average Coupon': [{ slotName: 'Iball_avgCoup' }]
			}[text];

			return [
				{ content: [first.join(' '), ' '], noWrap: false },
				{ content: [last, ...slots], noWrap: true }
			];
		}
	}
};
</script>

<style lang="less" scoped>
@import '~_css_/variables';

#fund-stat-body {
	.module-border-top();
	margin-bottom: 35px;

	.statistics-container {
		display: flex;

		.inline-item {
			color: @dark-gray;
			float: left;
			font-family: 'AvenirNextLTW01-Regular', Arial;
			margin-right: 2%;
			flex: 1 1 auto;

			.value {
				font-size: 18px;
			}

			.value-label {
				font-size: 12px;
			}
		}
	}

	.sub-info {
		clear: both;
		padding-top: 15px;
		font-size: 12px;
		font-family: 'AvenirNextLTW01-Condens 721299', Arial;
		color: @gray;
	}
}
</style>